<div class="card shadow-sm mx-auto" *ngIf="holidayRows.length; else noOfficialHolidays">
    <div class="px-3 py-2">
        <div class="d-flex flex-wrap align-items-center gap-2 small lh-sm text-muted">
            <span class="d-inline-flex align-items-center gap-1 me-3 text-nowrap" *ngFor="let holiday of holidayRows">
                <span class="d-inline-block rounded-pill flex-shrink-0"
                      style="width: 0.85rem; height: 0.85rem;"
                      [style.background-color]="holiday.color"></span>
                <span>{{ holiday.holidayLabel }} <span class="notranslate">({{ holiday.dateLabel }})</span></span>
            </span>
        </div>
    </div>
</div>
<ng-template #noOfficialHolidays>
    <p class="text-muted mb-0">No official holidays are available for this report.</p>
</ng-template>
